import { Component, OnInit, ViewChild, ViewContainerRef, ElementRef, TemplateRef, Output, EventEmitter, Input, AfterViewInit} from '@angular/core';

import { EditService, ToolbarService, PageService, GridComponent, FilterService, PdfExportService, SelectionService, SortService, RowDataBoundEventArgs, modelChanged, IFilter, TextWrapSettingsModel, GroupSettingsModel, columnSelectionComplete } from '@syncfusion/ej2-angular-grids';
import { DataManager, Query, Predicate, ODataV4Adaptor, ReturnOption, DataUtil } from '@syncfusion/ej2-data';
import { Browser, getComponent, isNullOrUndefined  } from '@syncfusion/ej2-base';
import { DropDownButtonModule, BeforeOpenCloseMenuEventArgs } from '@syncfusion/ej2-angular-splitbuttons';
import { QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { Popup } from '@syncfusion/ej2-popups';

import { RuleModel } from '@syncfusion/ej2-querybuilder';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { DemoService } from './../../../../demo.service';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { HotToastService } from '@ngneat/hot-toast';

import { BsModalService } from 'ngx-bootstrap';
import { SearchContact } from './../../../../shared/models/searchContact.model';
import { DatePipe } from '@angular/common';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { SubjectService } from './../../../../api/subjectService';
import { SubjectAttendence } from './../../../../api/subjectAttenence';
import { SearchAgentMetrics } from './../../../../shared/models/searchAgentMetrics.model';
import { Brand } from './../../../../shared/models/brand.model';


import { TabsetComponent } from 'ngx-bootstrap/tabs';

import * as c3 from 'c3';
import * as d3 from 'd3';
import { color } from 'd3-color';
import { Observable } from 'rxjs';

// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'app-agent-performance-metrics-attempts-dashboard',
  templateUrl: './agent-performance-metrics-attempts-dashboard.component.html',
  styleUrls: ['./agent-performance-metrics-attempts-dashboard.component.scss'],
  providers: [ToolbarService, EditService, PageService, ToolbarService,
    PdfExportService, PageService, FilterService, SortService, SelectionService]
})
export class AgentPerformanceMetricsAttemptsDashboardComponent implements OnInit {


  @ViewChild('querybuilder') qryBldrObj: QueryBuilderComponent;
  @ViewChild('grid') grid: GridComponent;
  isPopup:boolean = true;

  @ViewChild('chart') chart: c3.ChartAPI;
  @ViewChild('company_report_graph') company_report_graph;
    // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;

  @ViewChild('agent_metrics_chart_full') agent_metrics_chart_full: c3.ChartAPI;
  @ViewChild('div1') div1: c3.ChartAPI;

  // createdControl(): void {
  //   if (Browser.isDevice) {
  //     this.qryBldrObj.summaryView = true;
  //   }
  // }

  //  importRules: RuleModel = {
  //     'condition': 'and',
  //     'rules': [{
  //             'label': 'Order ID',
  //             'field': 'OrderID',
  //             'type': 'number',
  //             'operator': 'equal',
  //             'value': 10250
  //         },
  //         {
  //             'label': 'Customer Name',
  //             'field': 'CustomerName',
  //             'type': 'string',
  //             'operator': 'equal',
  //             'value': "Antonio Moreno"
  //         }]
  //     };



  metric_global_colour = '#5FDDB3'; // aqua score colour
  metric_global_icon = 'fa fa-clock-o';


  metric_1_colour = '#457EDD'; // blue
  metric_1_icon = 'fa fa-clock-o';
  metric_2_colour = '#000'; //  Pink
  metric_2_icon = 'fa fa-clock-o';
  metric_3_colour = '#A2D369'; // 
  metric_3_icon = 'fa fa-clock-o';
  metric_4_colour = '#FA6F50'; // 
  metric_4_icon = 'fa fa-clock-o';
  metric_5_colour = '#FECF56'; // 
  metric_5_icon = 'fa fa-clock-o';
  metric_6_colour = '#62ADE5'; // sharmans lite blue
  metric_6_icon = 'fa fa-clock-o';



  public groupOptions: GroupSettingsModel;
  public filter : IFilter;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  valueDatePickerDate: any;
  search_model: SearchAgentMetrics;
  toolbarOptions: string[];
  initialPage: { pageSize: number; };
  filterOptions: { type: string; };
  formatOptions: { type: string; format: string; };
  public wrapSettings: TextWrapSettingsModel; // this allows the content to wrap only Header|Content|Both

  brand_types: Object;
  users: any;
  usersPrimary: Object;
  contact_search: Object;
  contact_search_results: any;
  job_metrix_join_results: any[];
  brand_user_join_results: any[];
  brand_search: Object;
  brand_search_results: any;
  brand_user_join_results_agent: any[];
  brand_search_results_agent: any;
  user_levels: Object;
  user_search: Object;
  user_search_results: any;
  search_results: any;
  dateFormat: string;

  pageOptions: { pageSize: number; };
  join_results: any[];
  agent_services: Object;
  agent_services_results: any;
  agent_jobs: any;
  agent_jobs_count: any;
  combo_model: Brand;
  brands_agent: any;

  // public job_fields: Object = { text: 'subject_id', value: 'subject_id' };
  public job_fields: Object = { text: 'subject_number', value: 'subject_number' };
  jobs: Object;
  subject_service_metrix_search: any;
  subject_service_metrix_search_results: any;
  modalRef: any;
  // company_report_graph: any;
  metric_1_words: string;
  metric_1_who_service: any;
  metric_1_subject_service_id: any;
  metric_1_date_1: any;
  metric_1_date_2: Date;
  metric_1: number;
  metric_1_hours: number;
  metric_1_text: string;
  metric_1_title: string;
  metric_1_subject_id: any;
  metric_1_subject_number: any;
  metric_1_data: any[];
  metric_2_data: any[];
  metric_2_data_join: any[];
  metric_2_date_1: any;
  metric_2_date_2: Date;
  metric_2: number;
  metric_3_data: any[];
  metric_3_date_1: Date;
  metric_3_date_2: Date;
  metric_3: number;
  metric_3_data_join: any[];
  metric_1_data_join: any[];
  metric_4_data: any;
  metric_4_date_1: Date;
  metric_4_date_2: Date;
  metric_4: number;
  metric_4_data_join: any[];
  metric_5_data: any;
  metric_5_date_1: Date;
  metric_5_date_2: Date;
  metric_5: number;
  metric_5_data_join: any[];
  metric_6_data: any;
  metric_6_date_1: Date;
  metric_6_date_2: Date;
  metric_6: number;
  metric_6_data_join: any[];
  config: any;
  typeOptions: string[];
  subject_service_metrix_search_full: any;
  subject_service_metrix_search_full_results: any;
  metric_1_result: string;
  metric_2_result: string;
  metric_3_result: string;
  metric_4_result: string;
  metric_5_result: string;
  metric_6_result: string;
  metric_1_count: any[];
  total_metic_1_count: number;
  metric_1_adverage_time_taken: number;
  metric_1_adverage_time_taken_words: string;
  metric_2_count: any[];
  metric_3_count: any[];
  metric_4_count: any[];
  metric_5_count: any[];
  metric_6_count: any[];
  total_metic_2_count: number;
  metric_2_adverage_time_taken: number;
  metric_2_adverage_time_taken_words: string;
  total_metic_3_count: number;
  metric_3_adverage_time_taken: number;
  metric_3_adverage_time_taken_words: string;
  total_metic_4_count: number;
  metric_4_adverage_time_taken: number;
  metric_4_adverage_time_taken_words: string;
  total_metic_5_count: number;
  metric_5_adverage_time_taken: number;
  metric_5_adverage_time_taken_words: string;
  total_metic_6_count: number;
  metric_6_adverage_time_taken: number;
  metric_6_adverage_time_taken_words: string;
  metric_2_string: string;
  arrayOfLinks: any[];
  brands_client: any;

  creating_search_data: number;

  public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
  count_of_items: number;
  search_model_duration_array: any[];
  metric_total_count: number;
  logs_search_kPI_benchmarks_global: any;
  count_logs_search_kPI_benchmarks_global: number;
  logs_search_kPI_benchmarks_global_GRID: any[];
  created_by_count_array_data: any[];
  all_items_count_array_data: any;
  all_items_count_array_data_count: any;
  logs_search_kPI_benchmarks_global_GRID_count: number;
  system_wide_adverage_metrics: any;
  duration_seconds: number;
  duration_minutes: number;
  duration_hours: number;


  constructor(    private http: HttpClient, private router: Router, route: ActivatedRoute,private _demoService: DemoService,
    public datepipe: DatePipe,
    public toastr: HotToastService,
    private _mysqlService: MysqlService, 
    public gfunc: GlobalFunctionsService,
    private modalService: BsModalService,) { }

  ngOnInit(): void {

    this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
    this.search_model = new SearchAgentMetrics();

this.loadSearchDefaults();

    this.getFormUserLevels();
    this.getBrandBrandTypes();
    this.getBrandsComboBoxAgents(this.combo_model);
    this.getJobsTableData();


    this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
    this.getBrandsComboBoxClients(this.combo_model);

    // this.mapJobTableLive(); // load the table data
    // this.mapJobTableLiveClients();
    // this.mapJobTableLiveAgents();
    // , 'PdfExport'
    this.toolbarOptions = ['ExcelExport', 'Search'];
    this.initialPage = { pageSize:5 };
    this.filterOptions = {
      type: 'Menu'
   };
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatOptions= {type:'date', format:'dd/MM/yyyy' };
   this.dateFormat = 'dd/MM/yyyy hh:mm a';
   this.filter = { params: { format: this.dateFormat } };
  this.pageOptions = { pageSize: 100 }; 
  this.wrapSettings = { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both

  }







  loadSearchDefaults(){
    // this.getSystemLogTypesWithBenchmarksStaff();

    
   const  search_model = {
      // "routerLink": this.current_route,
      // "kpi_log_type_array": '1,2',
      "limit": 2500000000,
      "when_from": this.removeDays(30),
      "when_to": this.addDays(0),
      "agent_id": 0,
      'brand_id_group': [],
      'brand_report_id_group': [],
      'subject_number_group': [],
      // "created_level": '5', --- commented out due to log types not having the correct created_level set in the logs for the past.
    // 'log_type_id_group': this.allLogTypesArray,

    }// set to empty to get all first.

    // this.getDateTimeDuration(this.search_model.when_from,this.search_model.when_to)

    this.search_model = search_model


    setTimeout(() => {  
// this.getJobServiceMetricsSubjectSearchFull(this.search_model) // load gloabl kpis with benchmarks with search
this.getLogsSearchKPIBenchmarksGlobalAgentAttempts(this.search_model)

     }, 1000);


  }



  logsSearchRemoveDays(search_model, days_to_remove){

    // this.getDateTimeDuration(search_model.when_from,search_model.when_to)

      this.search_model = {
        // "routerLink": this.current_route,
        // "kpi_log_type_array": '1,2',
        ...search_model,
        "limit": 2500000000,
        "when_from": this.removeDays(days_to_remove),
        "when_to": this.addDays(0),
        'Duration': search_model.Duration,
             // "created_level": '5', --- commented out due to log types not having the correct created_level set in the logs for the past.

        // 'log_type_id_group': this.allLogTypesArray,

      }// set to empty to get all first.
  // this.getLogsSearch(this.search_model)

  // this.search_model = new_search_model;

  // this.getJobServiceMetricsSubjectSearchFull(this.search_model)
      this.getLogsSearchKPIBenchmarksGlobalAgentAttempts(this.search_model)
    }



  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
        this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'job_status';
    if (args.data[job_status] === 'CLOSED') {
        args.row.className = 'strikethrough';
    }
  }
  
  refreshGrid(){ // refresh the databutton
    this.mapJobTableLive();
    this.grid.refresh();
  }mapJobTableLive() {
    throw new Error('Method not implemented.');
  }
;
  
  
  
  
  getBrandBrandTypes(){
    this._demoService.getBrandBrandTypes().subscribe(
      data => { this.brand_types = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobsTableData(){
    this._demoService.getJobsTableData().subscribe(
      data => {this.jobs = data;
      let res = data[0];
      }
    )
  }
  
  getUsers() {
    this._demoService.getUsers().subscribe(
      data => { this.users = data;
        this.usersPrimary = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
  
  
  brandView(brand_id) {
    this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
  }
  
  brandEdit(brand_id) {
    this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
  }
  
  
  userView(user_id) {
    this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
  }
  
  userEdit(user_id) {
    this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
  }


  
  getFormUserLevels() {
    this._demoService.getFormUserLevels().subscribe(
       data2 => { this.user_levels = data2;
        console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Levels')
     );
   }



   getBrandsComboBoxAgents(combo_model) {
    this.combo_model.brand_type_id = 3;
   this._demoService.getBrandsComboBox(combo_model).subscribe(
      data => { this.brands_agent = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getBrandsComboBoxClients(combo_model) {
    this.combo_model.brand_type_id = 2;
   this._demoService.getBrandsComboBox(combo_model).subscribe(
      data => { this.brands_client = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }




  getJobServiceMetricsSubjectSearch(search_model) {
    // clear all the data arrays first
    this.job_metrix_join_results = [];
    this.subject_service_metrix_search = [];
    this.metric_1_data_join = [];
    this.metric_2_data_join = [];
    this.metric_3_data_join = [];
    this.metric_4_data_join = [];
    this.metric_5_data_join = [];
    this.metric_6_data_join = [];
    this.metric_1_data = [];
    this.metric_2_data = [];
    this.metric_3_data = [];
    this.metric_4_data = [];
    this.metric_5_data = [];
    this.metric_6_data = [];
    this.metric_1 = null;
    this.metric_2 = null;
    this.metric_3 = null;
    this.metric_4 = null;
    this.metric_5 = null;
    this.metric_6 = null;
    // this.company_report_graph = this.company_report_graph.destroy();
  //  this.company_report_graph.chart.destroy();
  
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;
    this._demoService.getJobServiceMetricsSubjectSearch(search_model).subscribe(
      data => { this.subject_service_metrix_search = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subject_service_metrix_search_results = DataUtil.parse.parseJson(data);
        this.toastr.success('Data Recieved')
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }






  getJobServiceMetricsSubjectSearchFull(search_model) {

    this.creating_search_data = 1;
  // reset furst


  
    // clear all the data arrays first
    this.job_metrix_join_results = [];
    this.subject_service_metrix_search_full = [];
    this.subject_service_metrix_search_full_results = [];
    this.metric_1_data_join = [];
    this.metric_2_data_join = [];
    this.metric_3_data_join = [];
    this.metric_4_data_join = [];
    this.metric_5_data_join = [];
    this.metric_6_data_join = [];
    this.metric_1_data = [];
    this.metric_2_data = [];
    this.metric_3_data = [];
    this.metric_4_data = [];
    this.metric_5_data = [];
    this.metric_6_data = [];
    this.metric_1 = null;
    this.metric_2 = null;
    this.metric_3 = null;
    this.metric_4 = null;
    this.metric_5 = null;
    this.metric_6 = null;
  
    this.metric_1_count = []; // start of adverages and counts badges
    this.metric_2_count = [];
    this.metric_3_count = [];
    this.metric_4_count = [];
    this.metric_5_count = [];
     this.metric_6_count = [];
  
     this.arrayOfLinks = [];
  
  this.metric_1_adverage_time_taken = null;
  this.metric_1_adverage_time_taken_words = null;
  this.metric_2_adverage_time_taken = null;
  this.metric_2_adverage_time_taken_words = null;
  this.metric_3_adverage_time_taken = null;
  this.metric_3_adverage_time_taken_words = null;
  this.metric_4_adverage_time_taken = null;
  this.metric_4_adverage_time_taken_words = null;
  this.metric_5_adverage_time_taken = null;
  this.metric_5_adverage_time_taken_words = null;
  this.metric_6_adverage_time_taken = null;
  this.metric_6_adverage_time_taken_words = null;

  // new function to get the quieries.
  // getJobServiceMetricsSubjectSearchActivityCounts
  // getJobServiceMetricsSubjectSearchActivity
  this._demoService.getJobServiceMetricsSubjectSearchActivity(search_model)
  .pipe(
    this.toastr.observe({
      loading: 'Checking Global Metrics...',
      success: '🚀',
      error: '...😡...'
   })
   )
  .subscribe(
  data => { this.subject_service_metrix_search_full = data;
   let res = data[0];
    // pass so that the dates are correct in Sync
    // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
    this.subject_service_metrix_search_full_results = DataUtil.parse.parseJson(data);
    this.toastr.success('Data Recieved')

    // this.SetAttemptMetrics_Results(); /// Now  asepeate function setup some metrics.
    this.setAttemptMetrics_Full(this.subject_service_metrix_search_full);

  },
  err => console.error(err),
  // () => console.log('done loading Trace Types')
);
}










setAttemptMetrics_Full(model){



// do an if queiry if thes two are not set.
// This allows for all the code to stay in tact and run counts with new data retunr function seperated and load So I can check against new figures in PHP
this.subject_service_metrix_search_full = model
this.subject_service_metrix_search_full_results = DataUtil.parse.parseJson(model);




                // Count items of brand search to loop through
                let  count_of_items = Object.keys(this.subject_service_metrix_search_full).length;
                console.log('Count of Subject Attempts: ', count_of_items);
                // now loop and push to join model
                // let date = new Date(res.created_date * 1000);
                // let job_start_date = new Date(date);

this.count_of_items = count_of_items;
this.metric_total_count = count_of_items

  for(let i=0; i < count_of_items; i++) {
    let res2 = this.subject_service_metrix_search_full_results[i];

// console.log('date 1:', res.created_date);
// console.log('created:', res.created);

    // let date = new Date(res2.created_date * 1000);
    // let job_start_date = new Date(date);
    // let date1 = new Date(res2.created_date * 1000);
    // let date2 = new Date(res2.date_service);

    // // console.log('Date 1: ', date1);
    // // console.log('Date 2: ', date2);
  




    // let Time = date1.getTime() - date2.getTime(); // milliseconds
    // let Days = Time / (1000 * 3600 * 24); // Diference in Days
    // let millisecondsPerDay = 1000 * 60 * 60 * 24;
    // let num =  Days / millisecondsPerDay; // days as a decimal.
    //  metric_1 = Time;
    //  metric_1_words = this.dhm( Time );

// Reset every loop.
this.metric_1 = 0;
this.metric_2 = 0;
this.metric_3 = 0;
this.metric_4 = 0;
this.metric_5 = 0;
this.metric_6 = 0;
// this.metric_2_date_1 = null;
// this.metric_2_date_2 = null;


    // console.log('Days Calc: ', this.dhm( Time ) );

// ... Metric 1
// console.log('res.service_number: ', res.service_number);
// if (this.subject_service_metrix_search_full_results[i].service_number == 1) {
//   console.log('CreatedDate1 ', this.subject_service_metrix_search_full_results[i].created_date * 1000);
// date1 = new Date(this.subject_service_metrix_search_full_results[i].created_date * 1000);
// date2 = new Date(this.subject_service_metrix_search_full_results[i].date_service);
// this.metric_1 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// }
// date1 = new Date(res2.created_date * 1000);
// date2 = new Date(res2.date_service);
// metric_1 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives

// ... Metric 2
// console.log('full_service_number: ', this.subject_service_metrix_search_full_results[i].service_number);
// if (this.subject_service_metrix_search_full_results[i].service_number == '2') {
//   console.log('CreatedDate2 ', this.subject_service_metrix_search_full_results[i].created_date * 1000);
//   date1 = new Date(this.subject_service_metrix_search_full_results[i].created_date * 1000);
//   date2 = new Date(this.subject_service_metrix_search_full_results[i].date_service);
// this.metric_2 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// console.log('MEtric2 ', this.metric_2);
// console.log('Metric2 Format: ', this.convertMsToHM(this.metric_2));
// }
// ... Metric 3
// if (this.subject_service_metrix_search_full_results[i].service_number == 2) {
// date1 = new Date(this.metric_1);
// date2 = new Date(this.metric_2);
// this.metric_3 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// }
// ... Metric 4
// if (this.subject_service_metrix_search_full_results[i].service_number == 3) {
// date1 = new Date(this.subject_service_metrix_search_full_results[i].created_date * 1000);
// date2 = new Date(this.subject_service_metrix_search_full_results[i].date_service);
// this.metric_4 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// }
// ... Metric 5
// if (this.subject_service_metrix_search_full_results[i].service_number == 3) {
// date1 = new Date(metric_3);
// date2 = new Date(metric_4);
// this.metric_5 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// }
// ... metric 6 (only closed)
// console.log('Status: ', this.subject_service_metrix_search_full_results[i].job_status);
// if (this.subject_service_metrix_search_full_results[i].job_status === 'CLOSED') {
// date1 = new Date(this.subject_service_metrix_search_full_results[i].created_date * 1000);
// date2 = new Date(this.subject_service_metrix_search_full_results[i].updated_date * 1000);
// this.metric_6 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// }

    // if(res2.service_number === 2) {
    // metric_2 = Time;
    // metric_2_words = this.dhm( Time );
    // console.log('metric_2: ', metric_2);
    // }

    // if(res2.service_number === 2) {
    //   let date1 = new Date(metric_1);
    //   let date2 = new Date(metric_2);
    //   metric_3 = date1.getTime() - date2.getTime();
    //   metric_3_words = this.dhm( metric_3 );
    //   console.log('metric_3: ', metric_3);
    //   }




// ... Metric 1
// tslint:disable-next-line:max-line-length
this.metric_1_data = this.subject_service_metrix_search_full_results.filter((sbi)=>(sbi.service_number === '1' && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id));
if (this.metric_1_data.length != 0) { // only load if data
// if (JSON.stringify(this.metric_1_data) !== '[]') { // only load if data



// BASIC FUCNTION TO CHECK IF ENDS IN Z... (Conversions when I changed the job_create date...... 2/2/24)

this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date * 1000); //other wise old way do this....


// // For new date formates
// if(this.metric_1_data[0].created_date.toString().endsWith("Z")){
//           this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date ); // so if created_date ends in Z do this...
//         }
//  console.log('Date Ends With Z : ' + this.metric_1_date_1.toString().endsWith("Z")); // works must conver to a string first very important.


// // For new date timestring formats that append the timezone.        
// // 1701934777_646 //  more if string length now the last three digits are timezone remove to get correct date.... length = 13 - three ...
// let count_date_string = this.metric_1_data[0].created_date.length;

// // var str2 =  this.metric_1_date_1;
// // console.log('String2: ' + str2);
// // var count = 0;
// // for (let i = 0; i < str2.length; i++) {
// //   // console.log(i)
// //     count++;
// // }
// // let count_date_string = count;

// console.log('Created Date Length: ' + count_date_string)
// if(count_date_string == 13){
//   let str = this.metric_1_data[0].created_date.toString();
//   // str.substring(0, str.length-3);
//   console.log('Updated Date: ' + str.substring(0, str.length-3))
//  let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
//  this.metric_1_date_1 = new Date(modified_date * 1000);
// }


let count_date_string = this.metric_1_data[0].created_date.length;
console.log('Created Date Length: ' + count_date_string)
if(count_date_string == 13){
let str = this.metric_1_data[0].created_date.toString();
// str.substring(0, str.length-3);
console.log('Updated Date: ' + str.substring(0, str.length-3))
let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
this.metric_1_date_1 = new Date(modified_date * 1000);
}

// if undefined then is the javascript date I think...
if(count_date_string == undefined){
this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date)
}



this.metric_1_date_2 = new Date(this.metric_1_data[0].date_service);
this.metric_1 = this.metric_1_date_2.getTime() - this.metric_1_date_1.getTime(); // milliseconds // bigger date first so no negatives
console.log('job_id', this.metric_1_data[0].job_id);
console.log('created_date ', this.metric_1_data[0].created_date);
console.log('metric 1 date', this.metric_1_date_1);
console.log('metric 2 date', this.metric_1_date_2);
console.log('metric 1', this.metric_1);

// try setting an array and do a ngfor loop in template.
this.metric_1_data_join = [{
// ...this.metric_1_data[0],
// metric_1_date_1: this.metric_1_date_1,
// metric_1_date_2: this.metric_1_date_2,
// metric_1: this.metric_1, // milliseconds // bigger date first so no negatives
// metric_1_words: this.dhm( this.metric_1 ),
// metric_1_who_service: this.metric_1_data[0].who_service,
// metric_1_hours: this.returnHoursFunction(this.metric_1),
metric_1_text: 'Total Attempts',
metric_1_title: 'Metric A',
metric_total_count: count_of_items, // 
}];

// if(!isNaN(this.metric_1)){this.metric_1 = 0}
// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
this.metric_1_count.push({
metric_1_total: this.metric_1, // ms
});
this.arrayOfLinks.push(this.metric_1_data[0].subject_service_id);

// this.arrayOfLinks.push({
//   subject_service_id: this.metric_1_data[0].subject_service_id,
//   subject_id: this.metric_1_data[0].subject_id,
//   subject_name: this.metric_1_data[0].subject_name
// });


}// end if

// ... Metric 2
// tslint:disable-next-line:max-line-length
this.metric_2_data = this.subject_service_metrix_search_full_results.filter((sbi)=>(sbi.service_number === '2' && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id));
console.log('Metric2 data: ', JSON.stringify(this.metric_2_data));
// if (JSON.stringify(this.metric_2_data) !== '[]') { // only load if data
if (this.metric_2_data.length != 0) { 
this.metric_2_date_1 = new Date(this.metric_2_data[0].created_date * 1000);

let count_date_string = this.metric_2_data[0].created_date.length;
console.log('Created Date Length: ' + count_date_string)
if(count_date_string == 13){
let str = this.metric_2_data[0].created_date.toString();
// str.substring(0, str.length-3);
console.log('Updated Date: ' + str.substring(0, str.length-3))
let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
this.metric_2_date_1 = new Date(modified_date * 1000);
}

// if undefined then is the javascript date I think...
if(count_date_string == undefined){
this.metric_2_date_1 = new Date(this.metric_2_data[0].created_date)
}

this.metric_2_date_2 = new Date(this.metric_2_data[0].date_service);
this.metric_2 = this.metric_2_date_2.getTime() - this.metric_2_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
// this.metric_2_data_join = [{
//   ...this.metric_2_data[0],
//   metric_2_date_1: this.metric_2_date_1,
//   metric_2_date_2: this.metric_2_date_2,
//   metric_2: this.metric_2, // milliseconds // bigger date first so no negatives
//   metric_2_words: this.dhm( this.metric_2 ),
//   metric_2_who_service: this.metric_2_data[0].who_service,
//   metric_2_hours: this.returnHoursFunction(this.metric_2),
//   metric_2_text: 'Time to 2nd Attempt on Subject',
//   metric_2_title: 'Metric 2'
// }];

// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
// if(!isNaN(this.metric_2)){this.metric_2 = 0}
this.metric_2_count.push({
metric_2_total: this.metric_2, // ms
});
this.arrayOfLinks.push(this.metric_2_data[0].subject_service_id);

} // end if
// ... Metric 3 (Calculation between)
// tslint:disable-next-line:max-line-length
this.metric_3_data = this.subject_service_metrix_search_full_results.filter((sbi)=>(sbi.service_number === '2'  && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id));
if (JSON.stringify(this.metric_3_data) != '[]') { // only load if data
this.metric_3_date_1 = new Date(this.metric_1);
this.metric_3_date_2 = new Date(this.metric_2);
this.metric_3 = this.metric_3_date_2.getTime() - this.metric_3_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
// this.metric_3_data_join = [{
//   ...this.metric_3_data[0],
//   metric_3_date_1: this.metric_3_date_1,
//   metric_3_date_2: this.metric_3_date_2,
//   metric_3: this.metric_3, // milliseconds // bigger date first so no negatives
//   metric_3_words: this.dhm( this.metric_3 ),
//   metric_3_who_service: this.metric_3_data[0].who_service,
//   metric_3_hours: this.returnHoursFunction(this.metric_3),
//   metric_3_text: 'Time between 1st & 2nd Attempt on Subject',
//   metric_3_title: 'Metric 3'
// }];

// if(!isNaN(this.metric_3)){this.metric_3 = 0}
// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
this.metric_3_count.push({
metric_3_total: this.metric_3, // ms
});
// this.arrayOfLinks.push([
//   this.metric_2_data[0].subject_id
// ]);

} // end if

// ... Metric 4
// tslint:disable-next-line:max-line-length
this.metric_4_data = this.subject_service_metrix_search_full_results.filter((sbi)=>(sbi.service_number === '3'  && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id)); // attempt 3
if (JSON.stringify(this.metric_4_data) != '[]') { // only load if data
this.metric_4_date_1 = new Date(this.metric_4_data[0].created_date * 1000);

let count_date_string = this.metric_4_data[0].created_date.length;
console.log('Created Date Length: ' + count_date_string)
if(count_date_string == 13){
let str = this.metric_4_data[0].created_date.toString();
// str.substring(0, str.length-3);
console.log('Updated Date: ' + str.substring(0, str.length-3))
let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
this.metric_4_date_1 = new Date(modified_date * 1000);
}

// if undefined then is the javascript date I think...
if(count_date_string == undefined){
this.metric_4_date_1 = new Date(this.metric_4_data[0].created_date)
}


this.metric_4_date_2 = new Date(this.metric_4_data[0].date_service);
this.metric_4 = this.metric_4_date_2.getTime() - this.metric_4_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
// this.metric_4_data_join = [{
//   ...this.metric_4_data[0],
//   metric_4_date_1: this.metric_4_date_1,
//   metric_4_date_2: this.metric_4_date_2,
//   metric_4: this.metric_4, // milliseconds // bigger date first so no negatives
//   metric_4_words: this.dhm( this.metric_4 ),
//   metric_4_who_service: this.metric_4_data[0].who_service,
//   metric_4_hours: this.returnHoursFunction(this.metric_4),
//   metric_4_text: 'Time to 3rd Attempt on Subject.',
//   metric_4_title: 'Metric 4'
// }];

// if(!isNaN(this.metric_4)){this.metric_4 = 0}
// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
this.metric_4_count.push({
metric_4_total: this.metric_4, // ms
});

} // end if

// tslint:disable-next-line:max-line-length
this.metric_5_data = this.subject_service_metrix_search_full_results.filter((sbi)=>(sbi.service_number === '3' && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id));
if (JSON.stringify(this.metric_5_data) != '[]') { // only load if data
this.metric_5_date_1 = new Date(this.metric_3);
this.metric_5_date_2 = new Date(this.metric_4);
this.metric_5 = this.metric_5_date_2.getTime() - this.metric_5_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
// this.metric_5_data_join = [{
//   ...this.metric_5_data[0],
//   metric_5_date_1: this.metric_5_date_1,
//   metric_5_date_2: this.metric_5_date_2,
//   metric_5: this.metric_5, // milliseconds // bigger date first so no negatives
//   metric_5_words: this.dhm( this.metric_5 ),
//   metric_5_who_service: this.metric_5_data[0].who_service,
//   metric_5_hours: this.returnHoursFunction(this.metric_5),
//   metric_5_text: 'Time between 2nd & 3rd Attempt on Subject',
//   metric_5_title: 'Metric 5'
// }];

// if(!isNaN(this.metric_5 )){this.metric_5 = 0}
// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
this.metric_5_count.push({
metric_5_total: this.metric_5, // ms
});
} // end if

// tslint:disable-next-line:max-line-length
//   // removed so that any subject can be closed and be calculated.
this.metric_6_data = this.subject_service_metrix_search_full_results.filter((sbi)=>( sbi.service_number === '1' && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id && sbi.job_status === 'CLOSED')); // attempt 1
if (JSON.stringify(this.metric_6_data) != '[]') { // only load if data
this.metric_6_date_1 = new Date(this.metric_6_data[0].created_date * 1000);


let count_date_string = this.metric_6_data[0].created_date.length;
console.log('Created Date Length: ' + count_date_string)
if(count_date_string == 13){
let str = this.metric_6_data[0].created_date.toString();
// str.substring(0, str.length-3);
console.log('Updated Date: ' + str.substring(0, str.length-3))
let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
this.metric_6_date_1 = new Date(modified_date * 1000);
}

// if undefined then is the javascript date I think...
if(count_date_string == undefined){
this.metric_6_date_1 = new Date(this.metric_6_data[0].created_date)
// metric six has issue maybe changing thi above to date
// this.metric_6_date_1 = new Date(this.metric_6_data[0].created_date * 1000);

}






this.metric_6_date_2 = new Date(this.metric_6_data[0].updated_date * 1000);


let count_date_string2 = this.metric_6_data[0].updated_date.length;
console.log('Created Date Length: ' + count_date_string2)
if(count_date_string2 == 13){
let str2 = this.metric_6_data[0].updated_date.toString();
// str.substring(0, str.length-3);
console.log('Updated Date: ' + str2.substring(0, str2.length-3))
let modified_date = str2.substring(0, str2.length-3); // removes the last three chars if longer than 10 or = 13
this.metric_6_date_2 = new Date(modified_date * 1000);
}

if(count_date_string2 == 0){
this.metric_6_date_2 = this.gfunc.today // chaged Metric
}

// if undefined then is the javascript date I think...
if(count_date_string2 == undefined){
this.metric_6_date_2 = new Date(this.metric_6_data[0].updated_date)
}


// this.metric_6_date_2 = this.gfunc.today // chaged Metric

this.metric_6 = this.metric_6_date_2.getTime() - this.metric_6_date_1.getTime(); // milliseconds // bigger date first so no negatives
console.log('job_id', this.metric_6_data[0].job_id);
console.log('created_date ', this.metric_6_data[0].created_date);
console.log('updated_date ', this.metric_6_data[0].updated_date);
console.log('metric 1 date', this.metric_6_date_1);
console.log('metric 2 date', this.metric_6_date_2);
console.log('metric 6', this.metric_6);




// try setting an array and do a ngfor loop in template.
// this.metric_6_data_join = [{
//   ...this.metric_6_data[0],
//   metric_6_date_1: this.metric_6_date_1,
//   metric_6_date_2: this.metric_6_date_2,
//   metric_6: this.metric_6, // milliseconds // bigger date first so no negatives
//   metric_6_words: this.dhm( this.metric_6 ),
//   metric_6_who_service: this.metric_6_data[0].who_service,
//   metric_6_hours: this.returnHoursFunction(this.metric_6),
//   metric_6_text: 'Time Job Start to Closed (or last updated if not yet closed).',
//   metric_6_title: 'Metric 6'
// }];
// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
// if(!isNaN(this.metric_6)){this.metric_6 = 0}
this.metric_6_count.push({
metric_6_total: this.metric_6, // ms
});



} // end if




// console.log('Current Metric 2: ', this.metric_2);
// if (this.metric_2 == null) {
// // tslint:disable-next-line:max-line-length
// console.log('There is no secend attempt for subject: ' + this.subject_service_metrix_search_full_results[0].subject_number + ' ' + this.subject_service_metrix_search_full_results[0].subject_name );
// } else {
//  this.metric_2_string = this.convertMsToHM(this.metric_2);
// }


// if(JSON.stringify(this.metric_2_data) !== '[]') {
//   this.metric_2_result = this.convertMsToHM(this.metric_2);
//   } else {
//   this.metric_2_result = null;
//   }
//   if(JSON.stringify(this.metric_3_data) !== '[]') {
//     this.metric_3_result = this.convertMsToHM(this.metric_3);
//   } else {
//     this.metric_2_result = null;
//     }

// this is how I can cade in an push each row to the data grid
// tslint:disable-next-line:max-line-length
// this.agent_metrics_chart_full.data([ 'Subject ' + res.subject_number , this.convertMsToHM(Time) , '0', '0', '0', '0', '0']); // array or string


// res2.subject_number + ' ' + res2.subject_name + ' Agent: ' + res2.who_service_name + ' ::' + res2.subject_service_id
// res2.subject_number + ' ' + res2.subject_name + ' Agent: ' + res2.who_service_name



// 1/02/24 added here double up as when searching not loading second time 










// if (JSON.stringify(this.metric_1_data) !== '[]') { } // end if  // only load if there is a first service data




// UNCOMMENT FOR LIVE
// Only Load agents if an agent is selected otherwise crashes the system.....
if(this.search_model.agent_id >= 1 && count_of_items >= 1){



        // this.agent_metrics_chart_full.load({
        // columns: [
        // // tslint:disable-next-line:max-line-length
        // // ['x',  'Metric 1: 1st Attempt on ', 'Metric 2: 2nd Attempt ', 'Metric 3: Time between 1st - 2nd Attempt', 'Metric 4: 3rd Attempt ', 'Metric 5: Time between 2nd - 3rd Attempt', 'Metric 6: Filed to Closed - (or last updated)'],
        // // tslint:disable-next-line:max-line-length
        // // this.convertMsToHM(this.metric_6)
        // [res2.subject_number + ' ' + res2.subject_name + ' Agent: ' + res2.who_service_name, this.convertMsToHM(this.metric_1), this.convertMsToHM(this.metric_2), this.convertMsToHM(this.metric_3),  this.convertMsToHM(this.metric_4) ,  this.convertMsToHM(this.metric_5),  this.convertMsToHM(this.metric_6)],
        // ],
        // unload: ['SYSTEM AVERAGE'],
        // type: 'line',

        // });

}




      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
this.job_metrix_join_results.push({
 ...this.subject_service_metrix_search_full[i],
//  metric_1: metric_1,
//  metric_1_words: metric_1_words,
//  metric_2: metric_2,
//  metric_2_words: metric_2_words,
//  metric_3: metric_3,
//  metric_3_words: metric_3_words,
//  metric_4: metric_4,
//  metric_4_words: metric_4_words,
//  metric_5: metric_5,
//  metric_5_words: metric_5_words,
//  metric_6: metric_6,
//  metric_6_words: metric_6_words,
//  job_start_date: job_start_date,
});

} // end results for metric calcs and arrays loop.



if(this.subject_service_metrix_search != '[]'){ 

  this.total_metic_1_count = this.metric_1_count.filter((item) => item.metric_1_total)
  .map((item) => +item.metric_1_total)
  .reduce((sum, current) => sum + current);
  this.metric_1_adverage_time_taken = (this.total_metic_1_count / count_of_items ); // ms
  this.metric_1_adverage_time_taken_words = this.dhm(this.metric_1_adverage_time_taken);
  if (this.metric_1_count.length != 0) {}
  
  console.log('Current Metric 2 Count: ', this.metric_2_count);
  if (this.metric_2_count.length != 0) {}
  this.total_metic_2_count = this.metric_2_count.filter((item) => item.metric_2_total)
  .map((item) => +item.metric_2_total)
  .reduce((sum, current) => sum + current);
  // reset frirst incase of prevoise search
  this.metric_2_adverage_time_taken = (this.total_metic_2_count / count_of_items ); // ms
  this.metric_2_adverage_time_taken_words = this.dhm(this.metric_2_adverage_time_taken);
  
  
  if (this.metric_3_count.length != 0) {}
  this.total_metic_3_count = this.metric_3_count.filter((item) => item.metric_3_total)
  .map((item) => +item.metric_3_total)
  .reduce((sum, current) => sum + current);
  this.metric_3_adverage_time_taken = (this.total_metic_3_count / count_of_items ); // ms
  this.metric_3_adverage_time_taken_words = this.dhm(this.metric_3_adverage_time_taken);
  
  
  if (this.metric_4_count.length != 0) {}
  this.total_metic_4_count = this.metric_4_count.filter((item) => item.metric_4_total)
  .map((item) => +item.metric_4_total)
  .reduce((sum, current) => sum + current);
  this.metric_4_adverage_time_taken = (this.total_metic_4_count / count_of_items ); // ms
  this.metric_4_adverage_time_taken_words = this.dhm(this.metric_4_adverage_time_taken);
  
  
  if (this.metric_5_count.length != 0) {}
  this.total_metic_5_count = this.metric_5_count.filter((item) => item.metric_5_total)
  .map((item) => +item.metric_5_total)
  .reduce((sum, current) => sum + current);
  this.metric_5_adverage_time_taken = (this.total_metic_5_count / count_of_items ); // ms
  this.metric_5_adverage_time_taken_words = this.dhm(this.metric_5_adverage_time_taken);
  
  
  if (this.metric_6_count.length != 0) {}
  this.total_metic_6_count = this.metric_6_count.filter((item) => item.metric_6_total)
  .map((item) => +item.metric_6_total)
  .reduce((sum, current) => sum + current);
  this.metric_6_adverage_time_taken = (this.total_metic_6_count / count_of_items ); // ms
  this.metric_6_adverage_time_taken_words = this.dhm(this.metric_6_adverage_time_taken);
  
  
  
  
  // end all calulations and settups
              // this.agent_metrics_chart_full.load({
              //   columns: [
              //     // tslint:disable-next-line:max-line-length
              //     // ['x',  'Metric 1: 1st Attempt on ', 'Metric 2: 2nd Attempt ', 'Metric 3: Time between 1st - 2nd Attempt', 'Metric 4: 3rd Attempt ', 'Metric 5: Time between 2nd - 3rd Attempt', 'Metric 6: Filed to Closed - (or last updated)'],
              //       // tslint:disable-next-line:max-line-length
              //       // this.convertMsToHM(this.metric_6)
              //       ['AVERAGE_METRICS', this.convertMsToHM(this.metric_1_adverage_time_taken), this.convertMsToHM(this.metric_2_adverage_time_taken), this.convertMsToHM(this.metric_3_adverage_time_taken),  this.convertMsToHM(this.metric_4_adverage_time_taken) ,  this.convertMsToHM(this.metric_5_adverage_time_taken),  this.convertMsToHM(this.metric_6_adverage_time_taken)],
              //   ],
              //   // unload: ['SYSTEM AVERAGE'],
              //   type: 'area-spline',
              //   // type: 'bar',
              //   colors: {
              //     AVERAGE_METRICS: '#00ff00',
              // },
              // });
  
   } // end if.








}













SetAttemptMetrics_Results(){


   // Count items of brand search to loop through
   let  count_of_items = Object.keys(this.subject_service_metrix_search).length;
   // now loop and push to join model
   // let date = new Date(res.created_date * 1000);
   // let job_start_date = new Date(date);

   let Time;
   let date1;
   let date2;
   let metric_1;
   let metric_1_words;
   let metric_2;
   let metric_2_words;
   let metric_3;
   let metric_3_words;
   let metric_4;
   let metric_4_words;
   let metric_5;
   let metric_5_words;
   let metric_6;
   let metric_6_words;
   let metric_1_date;
   let metric_1_date_format;
   let metric_2_date;
   let metric_3_date;
   let metric_4_date;
   let metric_5_date;
   let metric_6_date;


   // ... Metric 1
this.metric_1_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '1'));
if (JSON.stringify(this.metric_1_data) !== '[]') { // only load if data

  this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date * 1000);
 
  // For new date formates
// if(this.metric_1_data[0].created_date.toString().endsWith("Z")){
//   this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date ); // so if created_date ends in Z do this...
// }
// console.log('Date Ends With Z : ' + this.metric_1_date_1.toString().endsWith("Z")); // works must conver to a string first very important.

 
  let count_date_string = this.metric_1_data[0].created_date.length;
  console.log('Created Date Length: ' + count_date_string)
  if(count_date_string == 13){
    let str = this.metric_1_data[0].created_date.toString();
    // str.substring(0, str.length-3);
    console.log('Updated Date: ' + str.substring(0, str.length-3))
   let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
   this.metric_1_date_1 = new Date(modified_date * 1000);
  }

  // if undefined then is the javascript date I think...
  if(count_date_string == undefined){
    this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date)
  }
  

this.metric_1_date_2 = new Date(this.metric_1_data[0].date_service);
this.metric_1 = this.metric_1_date_2.getTime() - this.metric_1_date_1.getTime(); // milliseconds // bigger date first so no negatives
console.log('job_id', this.metric_1_data[0].job_id);
console.log('created_date ', this.metric_1_data[0].created_date);
console.log('metric 1 date', this.metric_1_date_1);
console.log('metric 2 date', this.metric_1_date_2);
console.log('metric 1', this.metric_1);



// try setting an array and do a ngfor loop in template.
this.metric_1_data_join = [{
  ...this.metric_1_data[0],
  metric_1_date_1: this.metric_1_date_1,
  metric_1_date_2: this.metric_1_date_2,
  metric_1: this.metric_1, // milliseconds // bigger date first so no negatives
  metric_1_words: this.dhm( this.metric_1 ),
  metric_1_who_service: this.metric_1_data[0].who_service,
  metric_1_hours: this.returnHoursFunction(this.metric_1),
  metric_1_text: 'Time to 1st Attempt on Subject',
  metric_1_title: 'Metric 1'
}];
}// end if



}







 // staff perspective
 public getLogsSearchKPIBenchmarksGlobalAgentAttempts(search_model) {

  // clear the data first.
this.logs_search_kPI_benchmarks_global_GRID = [];
this.created_by_count_array_data = [];
this.all_items_count_array_data = [];
this.system_wide_adverage_metrics = []
this.count_logs_search_kPI_benchmarks_global = 0;
this.all_items_count_array_data_count = 0;

  // clear these first
//   this.job_metrix_join_results = [];
//   this.subject_service_metrix_search_full = [];
//   this.subject_service_metrix_search_full_results = [];
//   this.metric_1_data_join = [];
//   this.metric_2_data_join = [];
//   this.metric_3_data_join = [];
//   this.metric_4_data_join = [];
//   this.metric_5_data_join = [];
//   this.metric_6_data_join = [];
//   this.metric_1_data = [];
//   this.metric_2_data = [];
//   this.metric_3_data = [];
//   this.metric_4_data = [];
//   this.metric_5_data = [];
//   this.metric_6_data = [];
//   this.metric_1 = null;
//   this.metric_2 = null;
//   this.metric_3 = null;
//   this.metric_4 = null;
//   this.metric_5 = null;
//   this.metric_6 = null;

//   this.metric_1_count = []; // start of adverages and counts badges
//   this.metric_2_count = [];
//   this.metric_3_count = [];
//   this.metric_4_count = [];
//   this.metric_5_count = [];
//    this.metric_6_count = [];

//    this.arrayOfLinks = [];

// this.metric_1_adverage_time_taken = null;
// this.metric_1_adverage_time_taken_words = null;
// this.metric_2_adverage_time_taken = null;
// this.metric_2_adverage_time_taken_words = null;
// this.metric_3_adverage_time_taken = null;
// this.metric_3_adverage_time_taken_words = null;
// this.metric_4_adverage_time_taken = null;
// this.metric_4_adverage_time_taken_words = null;
// this.metric_5_adverage_time_taken = null;
// this.metric_5_adverage_time_taken_words = null;
// this.metric_6_adverage_time_taken = null;
// this.metric_6_adverage_time_taken_words = null;

  this.getDateTimeDuration(search_model.when_from,search_model.when_to)

  this.updateSavedFileName();
  
  this.logs_search_kPI_benchmarks_global = [];
  
  this._demoService.getJobServiceMetricsSubjectSearchActivityCounts(search_model)
  .pipe(
    this.toastr.observe({
      loading: 'Checking Global Metrics...',
      success: '🚀',
      error: '...😡...'
   })
   )
  .subscribe(
    (res) => {
      this.logs_search_kPI_benchmarks_global = res;
    
      //0: the first Recorst is the search metric table for current search model results
      //1: is the resutls for the created_by_user_count array

      // If I build a merged return resutls I need to fix the counts
      this.count_logs_search_kPI_benchmarks_global = Object.keys(this.logs_search_kPI_benchmarks_global[0]).length;
      // this.count_logs_search_kPI_benchmarks_global = 15;
    
      this.logs_search_kPI_benchmarks_global_GRID = [];

      this.created_by_count_array_data = []
      this.all_items_count_array_data = this.logs_search_kPI_benchmarks_global[2] // all times 
        this.subject_service_metrix_search_full_results =  DataUtil.parse.parseJson(this.all_items_count_array_data);// just set the original metrics with original returned results for now... to keep in tact.


      // system wide response 4
      this.system_wide_adverage_metrics = this.logs_search_kPI_benchmarks_global[3] // 


        // Need to run the traditional metrics Calculations, based on these resutls, -- update function to take the model so its easier to
        // this.setAttemptMetrics_Full(this.all_items_count_array_data)

      // this.all_items_count_array_data_count = this.all_items_count_array_data.length;
      this.all_items_count_array_data_count = Object.keys(this.all_items_count_array_data).length;

      for(let i=0;i < this.count_logs_search_kPI_benchmarks_global; i++) {
        let res = this.logs_search_kPI_benchmarks_global[i];

       
       // Flattern the return s grid can read the data
       if(this.logs_search_kPI_benchmarks_global[0][i]){
        this.logs_search_kPI_benchmarks_global_GRID.push({
          ...this.logs_search_kPI_benchmarks_global[0][i]
        })
      }

        this.logs_search_kPI_benchmarks_global_GRID_count = this.logs_search_kPI_benchmarks_global_GRID.length;


     
      // Flattern the return s grid can read the -- user_created_data
      // if(this.logs_search_kPI_benchmarks_global[1][i].user_id){ // removed so I could show empties
        if(this.logs_search_kPI_benchmarks_global[1][i]){ // removed so I could show empties

        this.created_by_count_array_data.push({
          ...this.logs_search_kPI_benchmarks_global[1][i]
        })
     } 

    // Flattern the return s grid can read the -- ALL ITEMLS // as default returned resulsts... all log items
        // if(this.logs_search_kPI_benchmarks_global[2]){
        //   this.all_items_count_array_data.push({
        //     ...this.logs_search_kPI_benchmarks_global[2][i]
        //   })
        // }

      }
     
     
    
            },
    (err) => {console.error(err.status)}
  );
} /* */










 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};


deleteSubjectService(subject_service_id) {
  if (confirm('Are you sure you want to delete this Service Information? ')) {
    this._demoService.deleteSubjectService(subject_service_id).subscribe(
       data => {
       // this.getSubjectServices(this.subject_id);
        // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
         return true;
       },
       error => {
         console.error('Error deleting Attendence!');
        return console.log(error);
       }
    );
}
}










// ::@https://stackoverflow.com/questions/8528382/javascript-show-milliseconds-as-dayshoursmins-without-seconds
dhm (ms) {
  const days = Math.floor(ms / (24*60*60*1000));
  const daysms = ms % (24*60*60*1000);
  const hours = Math.floor(daysms / (60*60*1000));
  const hoursms = ms % (60*60*1000);
  const minutes = Math.floor(hoursms / (60*1000));
  const minutesms = ms % (60*1000);
  const sec = Math.floor(minutesms / 1000);
//  let days_words;
//  let hours_words;
//  let minutes_words;
//  let sec_words;
//   if (days) {  days_words = days + " DAYS, "; };
//   if (hours) {  hours_words = hours + " HOURS, "; };
//   if (minutes) {  minutes_words = minutes + " MINS, "; };
//   if (sec) {  sec_words = sec + " SECS."; };
  return days + " DAYS : " + hours + " HRS : " + minutes + " MINS : " + sec +" SECS";
  // return days_words  + hours_words + minutes_words + sec_words;



}



returnHoursFunction (ms) {
  const days = Math.floor(ms / (24*60*60*1000));
  const daysms = ms % (24*60*60*1000);
  const hours = Math.floor(daysms / (60*60*1000));
  const hoursms = ms % (60*60*1000);
  const minutes = Math.floor(hoursms / (60*1000));
  const minutesms = ms % (60*1000);
  const sec = Math.floor(minutesms / 1000);
//  let days_words;
//  let hours_words;
//  let minutes_words;
//  let sec_words;
//   if (days) {  days_words = days + " DAYS, "; };
//   if (hours) {  hours_words = hours + " HOURS, "; };
//   if (minutes) {  minutes_words = minutes + " MINS, "; };
//   if (sec) {  sec_words = sec + " SECS."; };
  return minutes;
  // return days_words  + hours_words + minutes_words + sec_words;



}


  // roundTo(123.456, 2);  // 123.46
  roundTo(num: number, places: number) {
    // let factor = 10 ** places;
    // return Math.round(num * factor) / factor;
    return num.toFixed(places);
  };

// ::@https://bobbyhadz.com/blog/javascript-convert-milliseconds-to-hours-and-minutes
  padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

convertMsToHM(milliseconds) {
  let seconds = Math.floor(milliseconds / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);

  seconds = seconds % 60;
  // 👇️ if seconds are greater than 30, round minutes up (optional)
  minutes = seconds >= 30 ? minutes + 1 : minutes;

  minutes = minutes % 60;

  // 👇️ If you don't want to roll hours over, e.g. 24 to 00
  // 👇️ comment (or remove) the line below
  // commenting next line gets you `24:00:00` instead of `00:00:00`
  // or `36:15:31` instead of `12:15:31`, etc.
 // hours = hours % 24;
console.log(`${this.padTo2Digits(hours)}:${this.padTo2Digits(minutes)}`);
// changed to dot to come as a percentage to load in graphs?

// added additional check so that nulls and NaN's are not returned
if (minutes > 0) {
  return `${this.padTo2Digits(hours)}.${this.padTo2Digits(minutes)}`;
}else {
  return null;
}
}




getTimeFromNow(a, b){

  const firstDate: Date = b;
  const secondDate: Date = a;
  
  return moment(b, 'YYYYMMDD').fromNow()
  
  }
  
  
  
  
    // From Now.
    addDays(days : number): Date{
      let futureDate = new Date();
      futureDate.setDate(futureDate.getDate() + days);
      return futureDate;
      }
      
      
      removeDays(days : number): Date{
      let futureDate = new Date();
      futureDate.setDate(futureDate.getDate() - days);
      return futureDate;
      }
  
  
  
  
      getDurationFromMillisenconds(t) {
        let year,
            month,
            day,
            hour,
            minute,
            second;
      
        second = Math.floor(t / 1000);
        minute = Math.floor(second / 60);
        second = second % 60;
        hour = Math.floor(minute / 60);
        minute = minute % 60;
        day = Math.floor(hour / 24);
        hour = hour % 24;
        month = Math.floor(day / 30);
        day = day % 30;
        year = Math.floor(month / 12);
        month = month % 12;
      
        this.search_model_duration_array = []; // empty first
      
        this.search_model_duration_array.push({
          year: year,
          month: month,
          day: day,
          hour: hour,
          minute: minute,
          second: second,
          });
          this.search_model_duration_array = this.search_model_duration_array;
      
      
        // return { year, month, day, hour, minute, second };
        return year + 'yrs ' +  month + ' months ' + day + ' days ' + hour + ' hrs ' + minute + ' mins ' + second + ' sec ' ;
      
      
        // rewrite this scipt to return a model and oject so I can choose to dispaly or not and make a better UI system with the data
      
      
      
      }
  





// Get Date Duration Between Two Dates
getDateTimeDuration(a,b){
  // const firstDate: Date = new Date('2023-12-21');
  // // Current Date
  // const secondDate: Date = new Date();
  
  
  this.search_model.Duration = 0;// set to null
  
  
  const firstDate: Date = b;
  const secondDate: Date = a;
  
  
  // Time Difference in Milliseconds
  const milliDiff: number = firstDate.getTime()
      - secondDate.getTime();
  
  // Converting time into hh:mm:ss format
  
  // Total number of seconds in the difference
  const totalSeconds = Math.floor(milliDiff / 1000);
  
  // Total number of minutes in the difference
  const totalMinutes = Math.floor(totalSeconds / 60);
  
  // Total number of hours in the difference
  const totalHours = Math.floor(totalMinutes / 60);
  
  // Getting the number of seconds left in one minute
  const remSeconds = totalSeconds % 60;
  
  // Getting the number of minutes left in one hour
  const remMinutes = totalMinutes % 60;
  
  console.log(`${totalHours}:${remMinutes}:${remSeconds}`);
  
  this.duration_seconds = totalSeconds;
  this.duration_minutes = totalMinutes;
  this.duration_hours = totalHours;
  
  // now run the function to build the duration model
  this.toastr.info('Re calculating Item Duration')
  
  // set back the main variables
  // this.model.Duration = milliDiff;
  // this.model.StartTime = a;
  // this.model.EndTime = b;
  
  this.search_model.Duration = milliDiff;
  this.search_model.when_from = a
  this.search_model.when_to = b
  
  
  return milliDiff; // returns the difference in milliseconds.
  }
  


  updateSavedFileName() {
    // const fromDate = this.datepipe.transform(this.search_model.when_from, 'dd_MMM_yyyy');
    // const toDate = this.datepipe.transform(this.search_model.when_to, 'dd_MMM_yyyy');
    const fromDate = this.datepipe.transform(this.search_model.when_from, 'dd_MMM_yyyy_HHmmss');
    const toDate = this.datepipe.transform(this.search_model.when_to, 'dd_MMM_yyyy_HHmmss');

    
    // Check if a specific user is selected
    let userPart = 'all';
    if (this.search_model.created_by) {
        const user = this.getUserById(this.search_model.created_by); // Replace with your method to get the user
        if (user) {
            userPart = `${user.first_name}_${user.surname}`;
        }
    }

    this.search_model.saved_file_name = `agent_attempts_${userPart}_metrics_${fromDate}_to_${toDate}`;
}

getUserById(userId: number) {
  return this.users?.find(user => user.user_id === userId);
  }



  saveAgentAttemptsMetricsData(search_model) {
    if (confirm('Save Metrics as a Footprint?')) {
  
    const dataToSave = {
        data: this.logs_search_kPI_benchmarks_global,         // Loaded data
        search_model: search_model,  // Search model
        saved_file_name: search_model.saved_file_name
    };
    this._demoService.saveAgentAttemptsMetricsData(dataToSave).subscribe(
        response => (console.log('Data saved successfully:', response),
      this.toastr.success('Saved.')
      ),
        error => console.error('Error saving data:', error)
    );
  }
   }


}
